import colors from "../../_colors.scss";

export const agriColors = Object.freeze([
  colors.ag1, colors.ag2, colors.ag3, colors.ag4, colors.ag5,
  colors.ag6, colors.ag7, colors.ag8, colors.ag9, colors.ag10,
  colors.ag11, colors.ag12, colors.ag13, colors.ag14, colors.ag15,
  colors.ag16, colors.ag17, colors.ag18, colors.ag19, colors.ag20,
]);
